"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILTER_TYPES_MAP = exports.BOND_DEFAULT_ORGANIZATION_ID = void 0;
const filter_classes_1 = require("./classes/filter.classes");
const filter_enums_1 = require("./enums/filter.enums");
exports.BOND_DEFAULT_ORGANIZATION_ID = 0;
exports.FILTER_TYPES_MAP = {
    [filter_enums_1.FilterTypeEnum.CALENDAR]: filter_classes_1.CalendarFilterOptions,
};
//# sourceMappingURL=consts.js.map